import { produce } from 'immer';
import { PrometheusQuerySpec } from '@/core';
import { createDataQueryPlugin, DataQueryPlugin } from '@/plugin-system';
import { PrometheusTimeSeriesQueryEditor } from './PrometheusTimeSeriesQueryEditor';
import { PrometheusTimeSeriesQueryPlugin } from './PrometheusTimeSeriesQueryPlugin';

const createPrometheusQuerySpec: DataQueryPlugin<PrometheusQuerySpec>['createInitialOptions'] = ({
  dataType,
  prevSpec,
}) => {
  const isTable = dataType === 'Table';

  if (prevSpec) {
    return produce(prevSpec, (draft) => {
      // Only table supports queryType and reducer
      if (isTable) {
        draft.queryType = 'Instant';
      } else {
        delete draft.queryType;
        delete draft.reducer;
      }
    });
  }

  return {
    query: '',
    queryType: isTable ? 'Instant' : undefined,
    datasource: undefined,
  };
};

/**
 * The core Prometheus TimeSeriesQuery plugin for viz framework.
 */
export const PrometheusTimeSeriesQuery = createDataQueryPlugin<PrometheusQuerySpec>({
  plugin: PrometheusTimeSeriesQueryPlugin,
  OptionsEditorComponent: PrometheusTimeSeriesQueryEditor,
  createInitialOptions: createPrometheusQuerySpec,
});
